export function defaultExamData(userId) {
  return {
    id: null,
    creator_id: userId,
    name: "",
    description: "",
  };
}

export function setNewExamData(id, exam) {
  return {
    ...exam,
    id: id,
  };
}


export const COLORS = [
  {
    border: "var(--blue)",
    button: "ghostBlue",
  },
  {
    border: "var(--red)",
    button: "ghostRed",
  },
  {
    border: "var(--gold)",
    button: "ghostGold",
  },
  {
    border: "var(--green)",
    button: "ghostGreen",
  },
];

export const EVALOPTIONS = {
  STILLSTUDYING: "This needs studying.",
  MASTERED: "You finally mastered this!",
  ALWAYSRIGHT: "You keep on getting this one!",
  ALMOSTTHERE: "Almost There"
}